export default __webpack_public_path__ + "static/media/hari.d7c8edb6.jpeg";